export const USER_TYPES = [
  { value: 'student', label: 'Student' },
  { value: 'corporate_employee', label: 'Corporate Employee' },
  { value: 'ngo_employee', label: 'NGO Employee' },
  { value: 'housewife', label: 'Housewife' },
];

export const userTypeLabel = (value) =>
  USER_TYPES.find((t) => t.value === value)?.label || value || '';

// Bengaluru localities for the location dropdown
export const BENGALURU_LOCALITIES = [
  'Indiranagar',
  'Koramangala',
  'Whitefield',
  'Jayanagar',
  'HSR Layout',
  'Bellandur',
  'Marathahalli',
  'JP Nagar',
  'Malleshwaram',
  'Yelahanka',
  'Electronic City',
  'BTM Layout',
  'Rajajinagar',
  'Banashankari',
  'Hebbal',
  'Sarjapur Road',
  'MG Road',
  'Basavanagudi',
  'RT Nagar',
  'Frazer Town',
  'Other',
];
